import { dew as _parseAvatarRecordDew } from "../../utils/ens/avatar/parseAvatarRecord.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _getEnsTextDew } from "./getEnsText.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getEnsAvatar = void 0;
  const parseAvatarRecord_js_1 = _parseAvatarRecordDew();
  const getAction_js_1 = _getActionDew();
  const getEnsText_js_1 = _getEnsTextDew();
  async function getEnsAvatar(client, {
    blockNumber,
    blockTag,
    gatewayUrls,
    name,
    universalResolverAddress
  }) {
    const record = await (0, getAction_js_1.getAction)(client, getEnsText_js_1.getEnsText, "getEnsText")({
      blockNumber,
      blockTag,
      key: "avatar",
      name,
      universalResolverAddress
    });
    if (!record) return null;
    try {
      return await (0, parseAvatarRecord_js_1.parseAvatarRecord)(client, {
        record,
        gatewayUrls
      });
    } catch {
      return null;
    }
  }
  exports.getEnsAvatar = getEnsAvatar;
  //# sourceMappingURL=getEnsAvatar.js.map
  return exports;
}